import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Grid,
  Paper,
  Typography,
  CircularProgress,
} from '@mui/material';
import { RootState } from '../store';

const Dashboard: React.FC = () => {
  const { items: products } = useSelector((state: RootState) => state.products);
  const { items: orders } = useSelector((state: RootState) => state.orders);

  const totalProducts = products.length;
  const totalOrders = orders.length;
  const totalRevenue = orders.reduce((sum, order) => sum + order.total_amount, 0);
  const pendingOrders = orders.filter((order) => order.status === 'pending').length;

  const stats = [
    {
      title: 'Total Products',
      value: totalProducts,
      color: '#1976d2',
    },
    {
      title: 'Total Orders',
      value: totalOrders,
      color: '#2e7d32',
    },
    {
      title: 'Total Revenue',
      value: `$${totalRevenue.toFixed(2)}`,
      color: '#ed6c02',
    },
    {
      title: 'Pending Orders',
      value: pendingOrders,
      color: '#9c27b0',
    },
  ];

  return (
    <Box>
      <Typography variant="h4" mb={3}>
        Dashboard
      </Typography>

      <Grid container spacing={3}>
        {stats.map((stat) => (
          <Grid item xs={12} sm={6} md={3} key={stat.title}>
            <Paper
              sx={{
                p: 3,
                display: 'flex',
                flexDirection: 'column',
                height: 140,
                bgcolor: stat.color,
                color: 'white',
              }}
            >
              <Typography variant="h6" gutterBottom>
                {stat.title}
              </Typography>
              <Typography variant="h4" component="div">
                {stat.value}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={3} sx={{ mt: 2 }}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Recent Orders
            </Typography>
            {orders.slice(0, 5).map((order) => (
              <Box key={order.id} sx={{ mb: 2 }}>
                <Typography variant="subtitle1">
                  Order #{order.id} - ${order.total_amount.toFixed(2)}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {new Date(order.created_at).toLocaleDateString()} - {order.status}
                </Typography>
              </Box>
            ))}
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Low Stock Products
            </Typography>
            {products
              .filter((product) => product.stock < 10)
              .slice(0, 5)
              .map((product) => (
                <Box key={product.id} sx={{ mb: 2 }}>
                  <Typography variant="subtitle1">{product.name}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Stock: {product.stock} units
                  </Typography>
                </Box>
              ))}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard; 